<template>
  <!-- Filters' Card -->
  <b-card body-class="py-1">
    <b-overlay :show="isGeoBusy" no-wrap opacity="0.4" rounded="lg">
      <template v-slot:overlay>
        <div class="d-flex align-items-center">
          <b-spinner small type="grow" variant="dark" />
          <b-spinner type="grow" variant="primary" />
          <b-spinner small type="grow" variant="dark" />
          <!-- We add an SR only text for screen readers -->
          <span class="sr-only">Chargement wait...</span>
        </div>
      </template>
    </b-overlay>

    <b-row>
      <b-col cols="12">
        <label>Rechercher une adresse</label>
        <vue-autosuggest
          id="selected"
          :suggestions="suggestedAddressOptions"
          :limit="4"
          :input-props="{
            id: 'autosuggest__input',
            class: 'form-control',
            placeholder: '51, Rue du Marché 69300 Caluire-et-Cuire',
          }"
          @input="onInputChange"
          @selected="onSelected"
          @blur="onBlur"
          :get-suggestion-value="getSuggestionValue"
          v-model="filters.address"
        >
          <template slot-scope="{ suggestion }">
            <span class="my-suggestion-item">{{
              suggestion.item.properties.label
            }}</span>
          </template>
        </vue-autosuggest>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest";
import { latLng } from "leaflet";
import { useDecimmoAPI } from "../useDecimmoSearcher";
import { BRow, BCol, BCard, BOverlay, BSpinner } from "bootstrap-vue";
import _ from "lodash";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BOverlay,
    BSpinner,

    // 3rd Party
    VueAutosuggest,
  },
  directives: {
    Ripple,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filterOptions: {
      type: Object,
      required: true,
    },
    isGeoBusy: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      lastSelectedAddress: this.filters.address,
      suggestedAddressOptions: [],
    };
  },
  setup() {
    const { fetchSuggestAddress } = useDecimmoAPI();

    return {
      fetchSuggestAddress,
    };
  },
  created() {
    // ADD DEBOUNCE TIMER FOR PERFORMANCE ISSUES
    this.debouncedFetchSuggestions = _.debounce(this.fetchSuggestions, 500);
  },
  methods: {
    // METHODS FOR ADDRESS AUTOSUGGEST
    onBlur() {
      // Force suggestion selection or reset field
      if (
        this.suggestedAddressOptions.length > 0 &&
        this.suggestedAddressOptions[0].data.filter(
          (sugg) => sugg.properties.label.toString() === this.filters.address
        ).length <= 0
      ) {
        this.filters.address = this.lastSelectedAddress;
      } else if (
        this.filters.address !== this.lastSelectedAddress &&
        this.suggestedAddressOptions.length === 0
      ) {
        this.filters.address = this.lastSelectedAddress;
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.properties.label;
    },
    onSelected(item) {
      this.lastSelectedAddress = item.item.properties.label.toString();
      this.filters.address = item.item.properties.label.toString();
      this.filters.center = latLng(
        item.item.geometry.coordinates[1],
        item.item.geometry.coordinates[0]
      );
      this.filters.userMarker = this.filters.center;
      this.filters.zipCode = item.item.properties.postcode.toString();
    },
    fetchSuggestions(text) {
      this.fetchSuggestAddress(text).then((response) => {
        this.suggestedAddressOptions = [
          {
            data: response.data.features,
          },
        ];
      });
    },
    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }
      this.debouncedFetchSuggestions(text);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>

<style lang="scss" scoped>
.categories-radio-group,
.brands-radio-group,
.price-range-defined-radio-group {
  ::v-deep > .custom-control {
    margin-bottom: 0.75rem;
  }
}

.input-group-text {
  border: 1px solid #d8d6de !important;
  font-size: 1rem !important;
  height: auto !important;
}
</style>
